/* Animación del número de cantidad (ficha de producto y carrito) */
(function () {
  function bump(input, dir) {
    if (!input) return;
    input.classList.remove('qty-up', 'qty-down');
    void input.offsetWidth;
    input.classList.add(dir > 0 ? 'qty-up' : 'qty-down');
  }
  document.addEventListener('animationend', function (e) {
    if (e.target.classList) e.target.classList.remove('qty-up', 'qty-down');
  });
  /* Fase de captura: se lee el valor ANTES de que el tema lo cambie */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest('[data-qty]');
    if (b && !b.disabled) {
      var w = b.closest('.qty'), i = w && w.querySelector('input');
      if (!i) return;
      var before = i.value, dir = b.getAttribute('data-qty') === 'plus' ? 1 : -1;
      setTimeout(function () { if (i.value !== before) bump(i, dir); }, 0);
      return;
    }
    var l = e.target.closest('[data-line-qty]');
    if (l && !l.disabled) {
      var w2 = l.closest('.qty'), i2 = w2 && w2.querySelector('input');
      if (!i2) return;
      var t = parseInt(l.getAttribute('data-line-qty'), 10), c = parseInt(i2.value, 10) || 0;
      if (!isNaN(t) && t >= 0 && t !== c) { i2.value = t; bump(i2, t > c ? 1 : -1); }
    }
  }, true);
})();
